import React from 'react';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Paper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Paper';
import { getLightBorder } from 'Components/utils';
import BottomSpacer from 'Components/ComponentLibrary/Components/Uncategorized/BottomSpacer';
import InputBar from './InputBar';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    ...getLightBorder(theme, { top: true }),
  },
}), { name: 'CommentsFooter' });

const CommentsFooter = () => {
  const classes = useStyles();


  return (
    <Paper
      className={classes.root}
    >
      <InputBar />
      <BottomSpacer />
    </Paper>
  );
};

export default CommentsFooter;
